<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div>
        <label class="ts-mb-0 required ts-font-robot">{{
          $t('task.title')
        }}</label>
        <div class="ts-flex ts-space-x-2">
          <input v-model="model.title" type="text" class="form-control" />
        </div>
        <div class="validate" v-if="errors.has('title')">
          {{ errors.first('title') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot required">{{
          $t('task.status')
        }}</label>
        <div class="ts-flex ts-space-x-2">
          <Select v-model="model.status_id" style="width:100%">
            <Option
              v-for="item in resources.status"
              :value="item.status_id"
              :key="item.status_id"
              >{{ item.project_status }}</Option
            >
          </Select>
        </div>
        <div class="validate" v-if="errors.has('status_id')">
          {{ errors.first('status_id') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot required">{{
          $t('task.priority')
        }}</label>
        <div class="ts-flex ts-space-x-2">
          <Select v-model="model.priority_id" style="width:100%">
            <Option
              v-for="item in resources.priority"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="validate" v-if="errors.has('priority_id')">
          {{ errors.first('priority_id') }}
        </div>
      </div>
      <!-- <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.project') }}</label>
        <div class="ts-flex ts-space-x-2">
          <Select
            v-model="model.project_id"
            :filterable="true"
            style="width:100%"
            @on-change="fetchModel"
          >
            <Option
              v-for="item in projectList"
              :value="item.project_id"
              :key="item.project_id"
              >{{ item.project_code + ' ' + item.project_name }}</Option
            >
          </Select>
          <button
            @click.prevent="showModalCreateProject"
            class=" ts-h-8 ts-flex ts-items-center ts-justify-center ts-text-white ts-font-semibold ts-font-robot ts-rounded-full ts-mr-3 focus:ts-outline-none"
            style="width: 2.2rem; background: rgba(126, 126, 126, 0.7); box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 10px, rgb(0, 0, 0) 0px 0px 0px;"
          >
            <Icon type="ios-add" size="20" />
          </button>
        </div>
        <div class="validate" v-if="errors.has('project_id')">
          {{ errors.first('project_id') }}
        </div>
      </div> -->
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.owner') }}</label>
        <div class="ts-flex ts-space-x-2">
          <Select
            :filterable="true"
            v-model="model.owner_id"
            style="width:100%"
          >
            <Option
              v-for="item in owners"
              :value="item.user_id"
              :key="item.user_id"
              >{{ item.employee_name_kh + ' ' + item.employee_name_en }}</Option
            >
          </Select>
        </div>
        <div class="validate" v-if="errors.has('owner_id')">
          {{ errors.first('owner_id') }}
        </div>
      </div>
      <div v-show="isShowFeeAmount">
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.feeAmount') }}</label>
        <div class="ts-flex ts-space-x-2">
          <input
            v-model="model.fee_amount"
            type="number"
            step="any"
            class="form-control"
          />
        </div>
        <div class="validate" v-if="errors.has('fee_amount')">
          {{ errors.first('fee_amount') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.milestone') }}</label>
        <div class="ts-flex ts-space-x-2">
          <Select
            v-model="model.milestone_id"
            :disabled="!this.model.project_id"
            style="width:100%"
          >
            <Option
              v-for="item in milestoneList"
              :value="item.milestone_id"
              :key="item.milestone_id"
              >{{ item.milestone_name }}</Option
            >
          </Select>
        </div>
        <div class="validate" v-if="errors.has('milestone_id')">
          {{ errors.first('milestone_id') }}
        </div>
      </div>
    </div>

    <iModalWrapper
      v-model="show_project"
      v-if="show_project"
      :title="$t('task.createProject')"
      width="50%"
    >
      <FormProject @cancel="onProjectCancel" @project="receiveProject" />
    </iModalWrapper>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import iModalWrapper from '../../components/i-modal-wrapper.vue'
import FormProject from './form-create-project.vue'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  props: ['value', 'validate', 'resources'],
  components: {
    iModalWrapper,
    FormProject
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      show_project: false,
      owners: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.model.project_id = this.$route.query.project_id
    this.model.milestone_id = this.$route.query.milestone_id
    this.fetchModel()
  },
  computed: {
    milestoneList() {
      if (this.resources.milestones) {
        return this.resources.milestones.filter(
          m => m.project_id == this.$route.query.project_id
        )
      }
      return []
    },
    projectList() {
      if (this.resources.projects) {
        return this.resources.projects
      }
      return []
    },
    isShowFeeAmount() {
      const allow = this.owners.find(o => o.user_id === this.model.owner_id)

      if (allow !== undefined) {
        return allow.is_sub_contractor
      }
      return false
    }
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    fetchModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'owner',
        project_id: this.$route.query.project_id
      })
        .then(response => {
          this.owners = response.data.owner
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    showModalCreateProject() {
      this.show_project = true
    },
    receiveProject(project) {
      this.model.project_id = project.project_id
      this.$emit('add-project', {
        project_code: project.project_code,
        project_id: project.project_id,
        project_name: project.project_name
      })
    },
    onProjectCancel() {
      this.show_project = false
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
